"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Vivien;
(function (Vivien) {
    var Type;
    (function (Type) {
        Type["Document"] = "DOCUMENT";
        Type["Health"] = "HEALTH";
    })(Type = Vivien.Type || (Vivien.Type = {}));
    var XmlnsOta;
    (function (XmlnsOta) {
        XmlnsOta["HTTPWWWOpentravelOrgOTA200305Beta"] = "http://www.opentravel.org/OTA/2003/05/beta";
    })(XmlnsOta = Vivien.XmlnsOta || (Vivien.XmlnsOta = {}));
    var OtaP;
    (function (OtaP) {
        OtaP["OtaPVisaRequired"] = "Visa required. ";
        OtaP["PassportRequired"] = "Passport required.";
        OtaP["VisaRequired"] = "Visa required.";
    })(OtaP = Vivien.OtaP || (Vivien.OtaP = {}));
    var OtaDocumentChildParagraphOtaParagraphType;
    (function (OtaDocumentChildParagraphOtaParagraphType) {
        OtaDocumentChildParagraphOtaParagraphType["Information"] = "Information";
        OtaDocumentChildParagraphOtaParagraphType["Requirement"] = "Requirement";
    })(OtaDocumentChildParagraphOtaParagraphType = Vivien.OtaDocumentChildParagraphOtaParagraphType || (Vivien.OtaDocumentChildParagraphOtaParagraphType = {}));
    var Empty;
    (function (Empty) {
        Empty["Health"] = "Health";
        Empty["Passport"] = "Passport";
        Empty["Visa"] = "Visa";
    })(Empty = Vivien.Empty || (Vivien.Empty = {}));
    var OtaBr;
    (function (OtaBr) {
        OtaBr["Empty"] = "";
    })(OtaBr = Vivien.OtaBr || (Vivien.OtaBr = {}));
    var OtaParagraphType1;
    (function (OtaParagraphType1) {
        OtaParagraphType1["Exception"] = "Exception";
        OtaParagraphType1["Information"] = "Information";
        OtaParagraphType1["Recommendation"] = "Recommendation";
        OtaParagraphType1["Requirement"] = "Requirement";
    })(OtaParagraphType1 = Vivien.OtaParagraphType1 || (Vivien.OtaParagraphType1 = {}));
    var OtaSubsectionName;
    (function (OtaSubsectionName) {
        OtaSubsectionName["AdditionalInformation"] = "Additional Information:";
        OtaSubsectionName["DocumentValidity"] = "Document Validity:";
        OtaSubsectionName["ExemptFromYellowFeverVaccination"] = "Exempt from Yellow Fever vaccination:";
        OtaSubsectionName["Minors"] = "Minors:";
        OtaSubsectionName["PassportExemptions"] = "Passport Exemptions:";
        OtaSubsectionName["Recommended"] = "Recommended:";
        OtaSubsectionName["VisaExemptions"] = "Visa Exemptions:";
        OtaSubsectionName["VisaIssuance"] = "Visa Issuance:";
        OtaSubsectionName["Warning"] = "Warning:";
    })(OtaSubsectionName = Vivien.OtaSubsectionName || (Vivien.OtaSubsectionName = {}));
})(Vivien = exports.Vivien || (exports.Vivien = {}));
//# sourceMappingURL=index.js.map